import lo from "./lo";
import licenses from "./licenses";

export default {
  namespaced: true,
  modules: {
    lo,
    licenses
  },
};
